/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PostAddIcon from '@material-ui/icons/PostAdd';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import ArchiveIcon from '@material-ui/icons/Archive';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import StarsIcon from '@material-ui/icons/Stars';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ListAltIcon from '@material-ui/icons/ListAlt';
import NoteIcon from '@material-ui/icons/Note';
import InputIcon from '@material-ui/icons/Input'


export default [

  {
    items: [
      {
        title: "لوحة التحكم",
        href: '/dashboard',
        icon: DashboardIcon
      },
    ],
  },
  {
    subheader: "العملاء",
    items: [
      {
        title: "العملاء",
        href: '/clients',
        icon: PeopleIcon
      },
      {
        title: "العروض المرفوضة",
        href: '/refuseoffers',
        icon: CancelPresentationIcon
      },
      {
        title: "تقييم العملاء",
        href: '/rates/clients',
        icon: StarsIcon,
      },
    ],
  },
  {
    subheader: "المحامين",
    items: [
      {
        title: "المحامين",
        href: '/lawyers',
        icon: AssignmentIndIcon
      },
      {
        title: "الطلبات",
        href: '/orders',
        icon: PostAddIcon,
        items:
          [
            {
              title: "استشارة قانونية",
              href: '/orders/advice'
            },
            {
              title: "الخدمات القانونية",
              href: '/orders/issue'
            },
          ]
      },
      {
        title: "الدعوات المرفوضة",
        href: '/refused',
        icon: CancelPresentationIcon
      },
      {
        title: "تقييم المحامين",
        href: '/rates/lawyers',
        icon: StarsIcon,
      },
    ],
  },
  {
    subheader: "الادارة",
    items: [
      {
        title: "طلبات السحب",
        href: '/balances',
        icon: MonetizationOnIcon,
      },
      // {
      //   title: "التقارير",
      //   href: '/reports',
      //   icon: NoteIcon,
      // },
      {
        title: "الاعدادات",
        href: '/settings',
        icon: SettingsApplicationsIcon,
        items:
          [
            {
              title: "الأعدادات العامة",
              href: '/settings/general'
            },
            // {
            //   title: "اسئلة التقييم",
            //   href: '/settings/questions'
            // },
            {
              title: "الدول",
              href: '/settings/countries'
            },
            {
              title: "اللغات",
              href: '/settings/languages'
            },
            {
              title: "الدرجات العلمية",
              href: '/settings/degrees'
            },
            {
              title: "التخصصات",
              href: '/settings/specialties'
            },
            {
              title: "نوع الترخيص",
              href: '/settings/levels'
            },
            {
              title: "البنوك",
              href: '/settings/banks'
            },
          ]
      },
      {
        title: "المديرين ",
        href: '/users',
        icon: ListAltIcon,
        items:
          [
            {
              title: "الأدوار و الصلاحيات",
              href: '/users/roles'
            },
            {
              title: "اعضاء الادارة",
              href: '/users/users'
            }
          ]
      },
    ]
  },
  {
    items: [
      {
        title: "تسجيل الخروج",
        href: '/auth/login',
        icon: InputIcon
      },
    ],
  },
]
